import { tw } from '@/utils/tw';
import { DialogTheme } from '@/components/Dialog/theme';

const PostActionDialogTheme = tw.theme({
  slots: {
    base: [],
  },
});

export default Object.assign(PostActionDialogTheme, {
  Dialog: DialogTheme,
});
